import { QueryConstraint } from 'firebase/firestore';
import { CollectionQueryOptions } from '../types/';
import { Milestone } from '../models/Milestone';
import { useCollection } from './useCollection';

export function useMilestones(
  query?: QueryConstraint[],
  options?: CollectionQueryOptions
) {
  return useCollection<Milestone>(
    'Milestones',
    query || [],
    options?.sorting || { sortField: 'dateCreated', sortDirection: 'desc' }
  );
}
